import React from "react";
import {
  MdCreditCard,
  MdDelete,
  MdStar,
  MdStarBorder,
  MdCheckCircle,
} from "react-icons/md";
import styles from "./PaymentMethodCard.module.scss";
import { useTheme } from "../../../../common/hooks/useTheme";
import { PaymentMethodInterface } from "../../../../common/types/types";

interface Props {
  method: PaymentMethodInterface;
  onSetDefault: (id: number) => void;
  onDelete: (id: number) => void;
  isSelectable?: boolean;
  isSelected?: boolean;
  onSelect?: () => void;
  disabled?: boolean; // 👈 новый пропс
}

export const PaymentMethodCard = ({
  method,
  onSetDefault,
  onDelete,
  isSelectable = false,
  isSelected = false,
  onSelect,
  disabled = false, // 👈 по умолчанию false
}: Props) => {
  const { theme } = useTheme();

  const getCardIcon = () => {
    return <MdCreditCard size={24} color={theme.primary} />;
  };

  const handleCardClick = () => {
    if (isSelectable && onSelect && !disabled) {
      onSelect();
    }
  };

  const handleSetDefault = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!disabled) {
      onSetDefault(method.id);
    }
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!disabled) {
      onDelete(method.id);
    }
  };

  return (
    <div
      className={`${styles.card} ${isSelectable ? styles.selectable : ""} ${isSelected ? styles.selected : ""} ${disabled ? styles.disabled : ""}`}
      style={{
        backgroundColor: theme.card,
        borderColor: isSelected ? theme.primary : theme.border,
        opacity: disabled ? 0.5 : 1,
      }}
      onClick={handleCardClick}
    >
      <div className={styles.header}>
        {isSelectable && (
          <div className={styles.radio}>
            {isSelected ? (
              <MdCheckCircle size={24} color={theme.primary} />
            ) : (
              <div
                className={styles.radioCircle}
                style={{ borderColor: theme.border }}
              />
            )}
          </div>
        )}
        <div className={styles.icon}>{getCardIcon()}</div>
        <div className={styles.info}>
          <div className={styles.number}>•••• {method.last4}</div>
        </div>
        {!isSelectable && (
          <div className={styles.actions}>
            <button
              className={styles.actionButton}
              onClick={handleSetDefault}
              title={method.is_default ? "Основная карта" : "Сделать основной"}
              disabled={disabled}
            >
              {method.is_default ? (
                <MdStar size={20} color={theme.primary} />
              ) : (
                <MdStarBorder size={20} color={theme.textSecondary} />
              )}
            </button>
            <button
              className={styles.actionButton}
              onClick={handleDelete}
              title="Удалить"
              disabled={disabled}
            >
              <MdDelete size={20} color={theme.danger} />
            </button>
          </div>
        )}
      </div>
      {method.is_default && !isSelectable && (
        <div
          className={styles.defaultBadge}
          style={{ backgroundColor: `${theme.primary}20` }}
        >
          <span
            className={styles.defaultBadgeText}
            style={{ color: theme.primary }}
          >
            Основная
          </span>
        </div>
      )}
    </div>
  );
};
